import { render, staticRenderFns } from "./SelectHospital.vue?vue&type=template&id=5a3bf352&scoped=true&"
import script from "./SelectHospital.vue?vue&type=script&lang=js&"
export * from "./SelectHospital.vue?vue&type=script&lang=js&"
import style0 from "./SelectHospital.vue?vue&type=style&index=0&id=5a3bf352&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3bf352",
  null
  
)

export default component.exports